import StatCard from "./components/StatCard";
import { UtilizationCard } from "./components/UtilizationCard";
import { StatCardProps, UtilizationData } from "../../utils/types";
import { useNavigate } from "react-router-dom";
import { OrganizationsModal } from "../OrganizationsModal";

type OrganizationClient = {
  client_code: string;
  client_name: string;
  client_logo: string | null;
};

export const StatsUtilizationSection = ({
  statsData = [],
  utilizationData,
  totalUsersRedirectPath,
  onTotalOrganisationsClick,
  isOrganizationsModalOpen,
  onOrganizationsModalOpenChange,
  organizations,
  isOrganizationsLoading,
}: {
  statsData?: StatCardProps[];
  utilizationData?: UtilizationData;
  totalUsersRedirectPath?: string;
  onTotalOrganisationsClick?: () => void;
  isOrganizationsModalOpen?: boolean;
  onOrganizationsModalOpenChange?: (open: boolean) => void;
  organizations?: OrganizationClient[];
  isOrganizationsLoading?: boolean;
}) => {
  const navigate = useNavigate();

  const mappedStatsData = statsData.map((item) => ({
    ...item,
    onClick:
      item.label === "Total Users" && totalUsersRedirectPath
        ? () => navigate(totalUsersRedirectPath)
        : item.label === "Total Organisations" && onTotalOrganisationsClick
        ? onTotalOrganisationsClick
        : item.onClick,
  }));

  return (
    <>
      <div className="grid grid-cols-6 gap-2 pr-4">
        {mappedStatsData?.map((item, index) => (
          <StatCard key={index} data={item} />
        ))}

        <UtilizationCard data={utilizationData} />
      </div>
      <OrganizationsModal
        open={Boolean(isOrganizationsModalOpen)}
        onOpenChange={onOrganizationsModalOpenChange || (() => {})}
        organizations={organizations}
        isLoading={isOrganizationsLoading}
      />
    </>
  );
};
